import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ElementLocale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import localeI18n from './i18n/index'
import util from './utils/util'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './assets/iconfont.css'
import './icons'
import BaiduMap from 'vue-baidu-map';
import Print from './plugins/print/Print'
Vue.use(Print)
Vue.use(BaiduMap, {
  ak: 'EniUt5ic7GTTUPwXQgnOL93KRwm25Y18'
})
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(VueI18n)
const i18n = new VueI18n(localeI18n)
ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.prototype.$http = util.http
Vue.prototype.$util = util

const vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default vm
